import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';

export const NOTIFICATION_EVENT_TRACKING_FRAGMENT = gql(`
  fragment NotificationEventTrackingFields on NotificationEventTracking {
    notificationType
    notificationId
    name
    position
    listingId
    cpId
    discountAmountCents
    discountAmountCurrency
    discountPercent
  }
`);

export const STREAM_PAGE_SIZE = 25;

export const NOTIFICATIONS_CENTER_QUERY = gql(`
  query NotificationsCenter($after: String) {
    notificationActions {
      summary
      actions {
        key
        title
        description
        iconName
        href
        links {
          label
          url
        }
        eventTracking {
          ...NotificationEventTrackingFields
        }
      }
    }
    notificationTasks {
      tasks {
        category
        title
        iconName
        unreadCount
        href
        eventTracking {
          ...NotificationEventTrackingFields
        }
      }
    }
    notificationStream(after: $after, limit: 25) {
      totalUnread
      nextCursor
      items {
        id
        kind
        severity
        title
        body
        eyebrow
        href
        iconName
        thumbnailUrl
        createdAt
        expiresAt
        isRead
        eventTracking {
          ...NotificationEventTrackingFields
        }
      }
    }
  }
`);

export function useNotificationsCenter(isOpen: boolean) {
  const { data, loading } = useQuery(NOTIFICATIONS_CENTER_QUERY, {
    skip: !isOpen,
    fetchPolicy: 'cache-and-network',
    variables: { after: null },
  });

  return { data, loading };
}
